import { render, staticRenderFns } from "./productFilterModal.vue?vue&type=template&id=5d2202a6&"
import script from "./productFilterModal.vue?vue&type=script&lang=js&"
export * from "./productFilterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports